import React from 'react'
import { Container } from './styles'
import { IconComponent } from '~/assets/icons/component'

export const Loading = ({ show }: { show: boolean }): JSX.Element => {
  if (!show) return <></>

  return (
    <Container data-testid="patient-container-loading">
      <IconComponent name="load" iconsize={50} />
    </Container>
  )
}
